import React from 'react';
import LandingBanner from 'shared/components/LandingBanner/LandingBanner';
import { useSelector } from 'react-redux';
import CombinedLoginScreen from './CombinedLoginScreen';

type Props = {
  fields: {
    backgroundimagedesktop: {
      url: string,
    },
    backgroundimagemobile: {
      url: string,
    },
    leftbody: string,
    leftbuttontext: string,
    leftbuttontextemail: string,
    leftheading: string,
    registrationbuttontext: string,
    rightbody: string,
    rightbuttontext: string,
    rightheading: string,
    rightbuttonurl: {
      alttext: string,
      analyticstag: string,
      cssclass: string,
      href: string,
      ismyracpage: boolean,
      openinnewwindow: boolean,
      title: string,
    },
    rightsecondarybuttonurl: {
      alttext: string,
      analyticstag: string,
      cssclass: string,
      href: string,
      ismyracpage: boolean,
      openinnewwindow: boolean,
      title: string,
    },
    insuranceregisterbutton: {
      alttext: string,
      analyticstag: string,
      cssclass: string,
      href: string,
      ismyracpage: boolean,
      openinnewwindow: boolean,
      title: string,
    },
  },
  loginCtaHandler: () => void,
  loginOneTimeEmailCtaHandler: () => void,
  registrationFormMyRacHandler: () => void,
}

const LoginScreenContainer = ({ fields, loginCtaHandler, loginOneTimeEmailCtaHandler, registrationFormMyRacHandler }: Props) => {
  const enabledMyRacCombinedLoginPage = useSelector<MyRACStore.Store>((state) => state.featureToggle?.enabledMyRacCombinedLoginPage)

  if (!enabledMyRacCombinedLoginPage) return <LandingBanner fields={fields} loginCtaHandler={loginCtaHandler} loginOneTimeEmailCtaHandler={loginOneTimeEmailCtaHandler} registrationFormMyRacHandler={registrationFormMyRacHandler} />

  return (
    <CombinedLoginScreen
      loginCtaHandler={loginCtaHandler}
      loginOneTimeEmailCtaHandler={loginOneTimeEmailCtaHandler}
      registrationFormMyRacHandler={registrationFormMyRacHandler}
    />
  )
}

export default LoginScreenContainer;
